import { render, staticRenderFns } from "./HuaxianSpecial.vue?vue&type=template&id=347886f3&scoped=true&"
import script from "./HuaxianSpecial.vue?vue&type=script&lang=js&"
export * from "./HuaxianSpecial.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianSpecial.vue?vue&type=style&index=0&id=347886f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347886f3",
  null
  
)

export default component.exports